import React, { useContext } from 'react'; 
import { BulkActionsContext } from 'shared/context/BulkActionsProvider';
import { Button, Icon } from 'semantic-ui-react';
import '../index.scss';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const Toolbar = ({ onOpenModal }) => {
    const [selectedDevices, , areDevicesInAllPagesSelected] = useContext(BulkActionsContext);
    const hasSelectedDevices = selectedDevices.length || areDevicesInAllPagesSelected;

    return (
        <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
            <div>
                <Button style={{marginRight: 10}} className='DevicesToolbar__button' disabled={!hasSelectedDevices || true} onClick={() => {}}>
                    Bulk Actions
                </Button>
                <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_ADD}>
                    <Button className='DevicesToolbar__button' onClick={onOpenModal}>
                        <Icon name='plus' />
                        New
                    </Button>
                </RestrictedView>
            </div>
        </div>

    )
}

export default Toolbar;
